<div class="form-group row" *ngIf="show">
    <label class="col-sm-8 col-form-label text-bold text-right mt-1 pr-0" for="{{prefixName}}_add_heatmaps" translate>
        Add Heatmaps
    </label>
    <div class="col-sm-40 mt-1 pl-4 d-flex align-items-center">
        <form-field-material-switch name="{{prefixName}}_add_heatmaps"
                                    [(ngModel)]="canUse"
                                    (ngChange)="onChangeValue()">
        </form-field-material-switch>
    </div>
</div>